import { TextInput } from '@mantine/core';

import classes from './index.module.css';

interface ITextFieldFilled {
  placeholder: string,
  ref?: any;
}

const TextFieldFilled = ({ placeholder, ref, ...props }: ITextFieldFilled) => {
  return (
    <TextInput
      variant='filled'
      placeholder={placeholder}
      classNames={{ input: classes.input, wrapper: classes.wrapper }}
      {...props}
      ref={ref}
    />
  )
}

export default TextFieldFilled;